import React, { Component } from "react";

import EmailForm from "./emailForm"

export class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data
    }
  }

  render() {
    return (
      <div>
        <div id="contact">
          <div className="container">
            <div className="col-md-8">
              <div className="row">
                <div className="section-title">
                  <h2>{this.props.data ? this.props.data.title : "loading"}</h2>
                  <p>{this.props.data ? this.props.data.subTitle : "loading"}</p>
                </div>
                <EmailForm data={this.props.data.formData}/>
                
              </div>
            </div>
            <div className="col-md-3 col-md-offset-1 contact-info">
              <div className="contact-item">
                <h3>{this.props.data ? this.props.data.contact : "loading"}</h3>
                
                  <span>
                    <i className="fa fa-map-marker"></i> {this.props.data ? this.props.data.addressLabel : "loading"}
                  </span>
                  {this.props.data ? this.props.data.address.map((d, i) => (<p key={`p-${i}`}>{d}</p>)) : "loading"}
                
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-phone"></i> {this.props.data ? this.props.data.phoneLabel : "loading"}
                  </span>{" "}
                  {this.props.data ? this.props.data.phone : "loading"}
                </p>
              </div>
              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-envelope-o"></i> {this.props.data ? this.props.data.emailLabel : "loading"}
                  </span>{" "}
                  {this.props.data ? this.props.data.email : "loading"}
                </p>
              </div>
            </div>
            {/* <div className="col-md-12">
              <div className="row">
                <div className="social">
                  <ul>
                    <li>
                      <a
                        href={this.props.data ? this.props.data.facebook : "/"}
                      >
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href={this.props.data ? this.props.data.twitter : "/"}>
                        <i className="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href={this.props.data ? this.props.data.youtube : "/"}>
                        <i className="fa fa-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
